import { withTestABComponent } from '@catalogo/service-americanas-common/src/hocs/testab-component';
import Sku from './old';
import SkuVariation from './new';

export default withTestABComponent(SkuVariation, Sku);
